import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import BulletinService from './service/edit';
import BulletinTMC from './tmc/edit';
import BulletinQuery from './list';

export const bulletinRoutes = [
  {'component': <BulletinService />, 'path': paths.BulletinService},
  {'component': <BulletinService />, 'path': paths.BulletinServiceEdit},
  {'component': <BulletinTMC />, 'path': paths.BulletinTMC},
  {'component': <BulletinTMC />, 'path': paths.BulletinTMCEdit},
  {'component': <BulletinQuery />, 'path': paths.BulletinQuery},
];
